import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { localization } from '@ocean/configs'
import { createApiAction } from 'api'
import { getRequirementDetails } from 'core/completion/api/completionService'
import { userLoggedOut } from 'core/session/slices/session'
import { setComment } from 'modules/requirements/RequirementCompletionDetails/api/requirementCompletionDetailsService'
import { ChangeCommentParams } from 'modules/requirements/RequirementCompletionDetails/types'
import { namespace } from 'modules/requirements/common/localization'
import {
  RequirementCompletionDetailsState,
  ApiCompletionDetailsResponse,
  ApiSetRequirementDetailsCommentResponse,
} from './types'

const { i18n } = localization

const I18_PATH = `${namespace}:requirementCompletionDetails`

const initialState: RequirementCompletionDetailsState = {
  completionDetailsData: {},
  setRequirementDetailsCommentRequest: {},
}

const requirementCompletionDetailsSlice = createSlice({
  name: 'requirementCompletionDetails',
  initialState,
  reducers: {
    completionDetailsLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiCompletionDetailsResponse>>
    ) {
      state.completionDetailsData = action.payload
    },
    clearCompletionDetails(state) {
      state.completionDetailsData = initialState.completionDetailsData
    },
    setRequirementDetailsCommentRequested(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiSetRequirementDetailsCommentResponse>>
    ) {
      state.setRequirementDetailsCommentRequest = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { completionDetailsLoaded, clearCompletionDetails, setRequirementDetailsCommentRequested } =
  requirementCompletionDetailsSlice.actions

export { clearCompletionDetails }
export default requirementCompletionDetailsSlice.reducer

export const loadRequirementDetailsData = (requirementId: Guid) => {
  return createApiAction({
    apiCalls: {
      completionDetails: () => getRequirementDetails(requirementId),
    },
    payloadAction: completionDetailsLoaded,
    getResultToKeep: state => state.requirementCompletionDetails.completionDetailsData.result,
  })
}

export const setRequirementDetailsCommentRequest = (
  requirementId: Guid,
  values: ChangeCommentParams
) => {
  return createApiAction({
    apiCalls: {
      setComment: () => setComment(requirementId, values),
    },
    payloadAction: setRequirementDetailsCommentRequested,
    enableErrorNotification: true,
    successMessage: i18n.t(`${I18_PATH}.comment.savedSuccessfully`),
  })
}
